import { IconButton } from '@mui/material';
import { FC } from 'react';
import styled from 'styled-components';
import { Close } from '@mui/icons-material';
import { useAppSelector } from '../../lib';

import { getDisabledCampaignText } from '../../lib/utils/get-disabled-campaign-text';
import { Campaign } from '../../types';
import { GenericField } from './form';

type CampainUnavailableProps = {
  campaign: Campaign;
  handleClose?: VoidFunction;
};

export const CampainUnavailable: FC<CampainUnavailableProps> = ({ campaign, handleClose }) => {
  const shouldReduceFieldsSize = useAppSelector((state) => state.config.reduceUISize);

  const getDisplayValue = (value: string): string => {
    return getDisabledCampaignText(value, campaign);
  };

  return (
    <>
      <CampaignNotAvailable bgColor={campaign.disabledScreen?.bgColor || '#000000dd'}>
        {(campaign.disabledScreen?.blocks || []).map((formField, index) => (
          <GenericField
            key={index}
            name={`campaign.disabledScreen.blocks[${index}]`}
            formField={formField}
            getDisplayValue={formField.type === 'text' ? getDisplayValue : undefined}
            reduceSize={shouldReduceFieldsSize}
          />
        ))}
      </CampaignNotAvailable>

      {handleClose && (
        <CloseButton
          aria-label="close"
          title="close"
          onClick={handleClose}
          style={{
            color: '#fff',
          }}
          size="large"
        >
          <Close fontSize="large" />
        </CloseButton>
      )}
    </>
  );
};

const CampaignNotAvailable = styled.div<{ bgColor: string }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 24px;
  text-align: center;
  position: absolute;
  inset: 0;
  z-index: 1;
  background-color: ${(p) => p.bgColor};
`;

const CloseButton = styled(IconButton)`
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 1;
`;
